import { BoxList } from 'approot/shared/design-system/box/box.style';
import { PStyled } from 'approot/shared/styles/typography.style';
import { canShowAttributionModificationDescription } from './logic/can-show-attribution-modification-description';
import { StimulusAttribution } from './stimulus.constants';

type Props = {
  attribution: StimulusAttribution;
};

const StimulusAttributionFields = ({ attribution }: Props) => {
  return (
    <BoxList>
      {attribution.author && (
        <li>
          <PStyled marginBottom={4}>Author: {attribution.author}</PStyled>
        </li>
      )}
      {attribution.copyright && (
        <li>
          <PStyled marginBottom={4}>Copyright: {attribution.copyright}</PStyled>
        </li>
      )}
      {attribution.licence && (
        <li>
          <PStyled marginBottom={4}>License: {attribution.licence}</PStyled>
        </li>
      )}
      {attribution.modifications && (
        <li>
          <PStyled marginBottom={4}>
            Modifications: {attribution.modifications}
          </PStyled>
        </li>
      )}
      {canShowAttributionModificationDescription(attribution) && (
        <li>
          <PStyled marginBottom={4}>
            Modification Description: {attribution.modificationDescription}
          </PStyled>
        </li>
      )}
    </BoxList>
  );
};

export default StimulusAttributionFields;
